module.exports = __webpack_public_path__ + "static/media/appStore.bad8a0f6.png";